/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { selectors as listSelectors } from '../../../../redux/ducks/lists/lists';
import { getMainProfileId } from '../../../redux/reduxSelectors';
import ProfileActions from '../../../redux/ProfileActions';
import { navigate } from '../../../redux/NavigationActions';
import { selectors as colorThemeSelectors } from '../../../../redux/ducks/lists/colorTheme';

import ProfileAvatar from '../../../../components/ProfileAvatar';
import RouteNames from '../../../RouteNames';
import ProfileModel from '../../../../../models/ProfileModel';
import FlexRow from '../../../../components/FlexRow';
import Card, { CardSection } from '../../../../components/card/Card';
import { Icons } from '../../../../../bphComponents/bundle';
import AppUtils from '../../../../../utilities/AppUtils';

function mapStateToProps(state) {
  return {
    colorThemes: listSelectors.getColorThemes(state),
    checkIsMainProfile: (id) => id === getMainProfileId(state),
    mainProfileColorTheme: colorThemeSelectors.getCurrentColorTheme(state),
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setActiveProfile: (profileData) => {
      dispatch(ProfileActions.switchToProfile(profileData));
    },
  };
}

interface Props {
  notification: {
    type: string;
    pending_data: {
      profile: {
        id: number;
        preferred_name: string;
        given_names: string;
        family_names: string;
        avatar_initials: string;
        avatar_photo: any;
        birth_sex_id: number;
        gender_id: number;
        date_of_birth: string;
        color_theme_id: number;
      };
    }
  };
  colorThemes: any[];
  checkIsMainProfile(id): boolean;
  setActiveProfile(profileData): void;
  mainProfileColorTheme: any;
}

const PendingDataNotification = (props: Props) => {
  const { notification, checkIsMainProfile, colorThemes, mainProfileColorTheme } = props;
  const profileData = notification.pending_data.profile;

  const cssProfileColor = AppUtils.cssColor(mainProfileColorTheme.accent_color);

  const profile = new ProfileModel(profileData);
  const isMainProfile = checkIsMainProfile(profileData.id);

  return (
    <Card>
      <CardSection hasBorder>
        <FlexRow className="font-body"style={{ width: '100%' }}>
          <div>
            {
              isMainProfile ? (
                <FormattedMessage id="notification.pendingData.user.message" />
              ) : (
                <FormattedMessage id="notification.pendingData.notUser.message" values={{ string1: profile.greetingName() }} />
              )
            }
          </div>


          <div style={{ marginLeft: 24 }}>
            <ProfileAvatar profile={profile} size={48} fontSize={15} />
          </div>
        </FlexRow>
      </CardSection>

      <CardSection hasBorder={false} isBottomCard className="bkgd-color-csAppBGgray">
        <button
          onClick={() => {
            props.setActiveProfile(profile.data);
            navigate(RouteNames.reviewPendingData());
          }}
          style={{ width: '100%', padding: 0 }}
        >
        <FlexRow className="font-body font-color-profile-accent">
          <FormattedMessage id="notification.pendingData.button.label" />

          <span style={{ display: 'flex', marginRight: 4 }}>
            <Icons.IconDataConnections.Medium color={cssProfileColor} />
          </span>
        </FlexRow>
        </button>
      </CardSection>
    </Card>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PendingDataNotification);
